var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 540,
    viewBox: "0 0 1440 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10836_135373",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -230,
    width: 1440,
    height: 1080
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -230,
    width: 1440,
    height: 1080,
    fill: "url(#paint0_radial_10836_135373)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10836_135373)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10836_135373)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1080,
    transform: "translate(0 -230)",
    fill: "#0E122F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10836_135373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M972 184C981.941 184 990 175.941 990 166C990 156.059 981.941 148 972 148C962.059 148 954 156.059 954 166C954 175.941 962.059 184 972 184Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972 173.827C976.322 173.827 979.826 170.323 979.826 166.001C979.826 161.678 976.322 158.175 972 158.175C967.678 158.175 964.174 161.678 964.174 166.001C964.174 170.323 967.678 173.827 972 173.827Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10836_135373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1332 184C1341.94 184 1350 175.941 1350 166C1350 156.059 1341.94 148 1332 148C1322.06 148 1314 156.059 1314 166C1314 175.941 1322.06 184 1332 184Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.85 158.952L1325.4 163.733H1330.43L1326.37 166.694L1327.92 171.475L1323.85 168.522L1319.78 171.475L1321.34 166.694L1317.27 163.733H1322.3L1323.85 158.952Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.34 175.877L1334.15 174.414L1332.39 175.097L1333.41 173.514L1332.22 172.045L1334.05 172.53L1335.07 170.948L1335.17 172.832L1337 173.318L1335.23 173.993L1335.34 175.877Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.7 171.588L1338.26 169.788L1336.72 168.698L1338.61 168.67L1339.16 166.87L1339.78 168.656L1341.66 168.635L1340.15 169.76L1340.75 171.546L1339.21 170.456L1337.7 171.588Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.89 161.21L1340.06 162.904L1341.41 164.219L1339.54 163.952L1338.72 165.64L1338.39 163.783L1336.52 163.516L1338.19 162.637L1337.87 160.774L1339.22 162.089L1340.89 161.21Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.39 156.078L1335.25 157.955L1337 158.665L1335.16 159.115L1335.03 160.999L1334.04 159.396L1332.2 159.846L1333.42 158.405L1332.42 156.809L1334.17 157.519L1335.39 156.078Z",
    fill: "#FFDA44"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_10836_135373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1099.12 244.262C1101.66 251.117 1108.26 256.002 1116 256.002C1123.74 256.002 1130.34 251.117 1132.88 244.262L1116 242.697L1099.12 244.262Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116 220.001C1108.26 220.001 1101.66 224.886 1099.12 231.74L1116 233.305L1132.88 231.74C1130.34 224.886 1123.74 220.001 1116 220.001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.12 231.739C1098.4 233.689 1098 235.798 1098 237.999C1098 240.201 1098.4 242.31 1099.12 244.26H1132.88C1133.6 242.31 1134 240.201 1134 237.999C1134 235.798 1133.6 233.689 1132.88 231.739H1099.12Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_10836_135373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900 328C909.941 328 918 319.941 918 310C918 300.059 909.941 292 900 292C890.059 292 882 300.059 882 310C882 319.941 890.059 328 900 328Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.217 310H917.999C917.999 308.375 917.783 306.801 917.379 305.304H899.217V310Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.217 300.608H915.357C914.256 298.81 912.847 297.22 911.204 295.912H899.217V300.608Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 328C904.236 328 908.13 326.536 911.204 324.087H888.795C891.87 326.536 895.763 328 900 328Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.642 319.39H915.358C916.243 317.946 916.929 316.369 917.38 314.694H882.62C883.071 316.369 883.757 317.946 884.642 319.39Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.338 294.811H891.978L890.452 295.919L891.035 297.713L889.51 296.605L887.984 297.713L888.487 296.164C887.144 297.283 885.966 298.594 884.996 300.054H885.522L884.551 300.76C884.399 301.012 884.254 301.269 884.115 301.529L884.579 302.957L883.714 302.328C883.498 302.784 883.302 303.25 883.125 303.725L883.636 305.298H885.522L883.996 306.406L884.579 308.2L883.053 307.092L882.139 307.756C882.048 308.491 882 309.24 882 310H900C900 300.059 900 298.887 900 292C896.444 292 893.129 293.031 890.338 294.811ZM891.035 308.2L889.51 307.092L887.984 308.2L888.567 306.406L887.041 305.298H888.927L889.51 303.504L890.092 305.298H891.978L890.452 306.406L891.035 308.2ZM890.452 301.163L891.035 302.957L889.51 301.848L887.984 302.957L888.567 301.163L887.041 300.054H888.927L889.51 298.261L890.092 300.054H891.978L890.452 301.163ZM897.492 308.2L895.966 307.092L894.44 308.2L895.023 306.406L893.497 305.298H895.383L895.966 303.504L896.549 305.298H898.435L896.909 306.406L897.492 308.2ZM896.909 301.163L897.492 302.957L895.966 301.848L894.44 302.957L895.023 301.163L893.497 300.054H895.383L895.966 298.261L896.549 300.054H898.435L896.909 301.163ZM896.909 295.919L897.492 297.713L895.966 296.605L894.44 297.713L895.023 295.919L893.497 294.811H895.383L895.966 293.017L896.549 294.811H898.435L896.909 295.919Z",
    fill: "#0052B4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_10836_135373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1260 328C1269.94 328 1278 319.941 1278 310C1278 300.059 1269.94 292 1260 292C1250.06 292 1242 300.059 1242 310C1242 319.941 1250.06 328 1260 328Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.22 310H1278C1278 308.375 1277.78 306.801 1277.38 305.304H1259.22V310Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.22 300.608H1275.36C1274.26 298.81 1272.85 297.22 1271.2 295.912H1259.22V300.608Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260 328C1264.24 328 1268.13 326.536 1271.2 324.087H1248.79C1251.87 326.536 1255.76 328 1260 328Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.64 319.39H1275.36C1276.24 317.946 1276.93 316.369 1277.38 314.694H1242.62C1243.07 316.369 1243.76 317.946 1244.64 319.39Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.34 294.811H1251.98L1250.45 295.919L1251.04 297.713L1249.51 296.605L1247.98 297.713L1248.49 296.164C1247.14 297.283 1245.97 298.594 1245 300.054H1245.52L1244.55 300.76C1244.4 301.012 1244.25 301.269 1244.12 301.529L1244.58 302.957L1243.71 302.328C1243.5 302.784 1243.3 303.25 1243.12 303.725L1243.64 305.298H1245.52L1244 306.406L1244.58 308.2L1243.05 307.092L1242.14 307.756C1242.05 308.491 1242 309.24 1242 310H1260C1260 300.059 1260 298.887 1260 292C1256.44 292 1253.13 293.031 1250.34 294.811ZM1251.04 308.2L1249.51 307.092L1247.98 308.2L1248.57 306.406L1247.04 305.298H1248.93L1249.51 303.504L1250.09 305.298H1251.98L1250.45 306.406L1251.04 308.2ZM1250.45 301.163L1251.04 302.957L1249.51 301.848L1247.98 302.957L1248.57 301.163L1247.04 300.054H1248.93L1249.51 298.261L1250.09 300.054H1251.98L1250.45 301.163ZM1257.49 308.2L1255.97 307.092L1254.44 308.2L1255.02 306.406L1253.5 305.298H1255.38L1255.97 303.504L1256.55 305.298H1258.43L1256.91 306.406L1257.49 308.2ZM1256.91 301.163L1257.49 302.957L1255.97 301.848L1254.44 302.957L1255.02 301.163L1253.5 300.054H1255.38L1255.97 298.261L1256.55 300.054H1258.43L1256.91 301.163ZM1256.91 295.919L1257.49 297.713L1255.97 296.605L1254.44 297.713L1255.02 295.919L1253.5 294.811H1255.38L1255.97 293.017L1256.55 294.811H1258.43L1256.91 295.919Z",
    fill: "#0052B4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_10836_135373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044 400C1053.94 400 1062 391.941 1062 382C1062 372.059 1053.94 364 1044 364C1034.06 364 1026 372.059 1026 382C1026 391.941 1034.06 400 1044 400Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062 382.002C1062 374.865 1057.85 368.699 1051.83 365.788V398.215C1057.85 395.304 1062 389.138 1062 382.002Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026 382.001C1026 389.137 1030.15 395.303 1036.17 398.215V365.787C1030.15 368.698 1026 374.864 1026 382.001Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.13 384.349L1050.26 382.784L1048.7 382.002V380.436L1045.57 382.002L1047.13 378.871H1045.57L1044 376.523L1042.44 378.871H1040.87L1042.44 382.002L1039.31 380.436V382.002L1037.74 382.784L1040.87 384.349L1040.09 385.915H1043.22V388.262H1044.78V385.915H1047.91L1047.13 384.349Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_10836_135373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1404 400C1413.94 400 1422 391.941 1422 382C1422 372.059 1413.94 364 1404 364C1394.06 364 1386 372.059 1386 382C1386 391.941 1394.06 400 1404 400Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.62 386.697C1387.66 390.561 1389.96 393.91 1393.04 396.282V386.697H1386.62Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.43 399.932C1402.95 399.977 1403.47 400.001 1404 400.001C1412.32 400.001 1419.31 394.36 1421.38 386.697H1402.43V399.932Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.38 377.305C1419.31 369.641 1412.32 364.001 1404 364.001C1403.47 364.001 1402.95 364.025 1402.43 364.069V377.305H1421.38Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.04 367.72C1389.96 370.092 1387.66 373.441 1386.62 377.306H1393.04V367.72Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.85 379.651H1400.09H1400.09V364.427C1398.42 364.796 1396.85 365.394 1395.39 366.188V379.651V379.651H1386.15C1386.05 380.42 1386 381.204 1386 381.999C1386 382.795 1386.05 383.579 1386.15 384.347H1395.39H1395.39V397.811C1396.85 398.605 1398.42 399.203 1400.09 399.571V384.347V384.347H1421.85C1421.95 383.579 1422 382.795 1422 381.999C1422 381.204 1421.95 380.42 1421.85 379.651Z",
    fill: "#0052B4"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_10836_135373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1188 472C1197.94 472 1206 463.941 1206 454C1206 444.059 1197.94 436 1188 436C1178.06 436 1170 444.059 1170 454C1170 463.941 1178.06 472 1188 472Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.39 450.87H1191.13V444.609H1184.87V450.87H1178.61V457.13H1184.87V463.391H1191.13V457.13H1197.39V450.87Z",
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_10836_135373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1350 526C1350 535.941 1341.94 544 1332 544C1322.06 544 1314 535.941 1314 526C1314 526.004 1332 508.002 1332 508C1341.94 508 1350 516.059 1350 526Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.95 526.001H1332C1332 525.984 1332 525.969 1332 525.952C1331.98 525.968 1331.97 525.985 1331.95 526.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 517.393C1332 514.225 1332 512.15 1332 508.001H1332C1322.06 508.003 1314 516.061 1314 526.001H1323.39V520.713L1328.68 526.001H1331.95C1331.97 525.985 1331.98 525.969 1332 525.953C1332 524.74 1332 523.658 1332 522.681L1326.71 517.393H1332Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.11 510.349C1320.29 511.952 1317.95 514.292 1316.35 517.107V526.001H1321.04V515.044V515.044H1332C1332 513.563 1332 512.152 1332 510.349H1323.11Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332 523.787L1325.61 517.392H1323.39C1323.39 517.392 1323.39 517.392 1323.39 517.392L1332 526.001H1332C1332 526.001 1332 524.475 1332 523.787Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.86 529.13L1325.84 531.195L1328.08 530.68L1327.08 532.74L1328.87 534.163L1326.64 534.666L1326.64 536.956L1324.86 535.523L1323.07 536.956L1323.08 534.666L1320.84 534.163L1322.64 532.74L1321.64 530.68L1323.87 531.195L1324.86 529.13Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.95 533.043L1341.45 534.076L1342.56 533.818L1342.06 534.848L1342.96 535.56L1341.84 535.811L1341.84 536.956L1340.95 536.24L1340.06 536.956L1340.06 535.811L1338.94 535.56L1339.84 534.848L1339.34 533.818L1340.46 534.076L1340.95 533.043Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.36 522.087L1336.85 523.12L1337.96 522.862L1337.47 523.892L1338.36 524.604L1337.25 524.855L1337.25 526L1336.36 525.284L1335.46 526L1335.47 524.855L1334.35 524.604L1335.25 523.892L1334.75 522.862L1335.86 523.12L1336.36 522.087Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.95 515.826L1341.45 516.859L1342.56 516.601L1342.06 517.632L1342.96 518.343L1341.84 518.595L1341.84 519.74L1340.95 519.023L1340.06 519.74L1340.06 518.595L1338.94 518.343L1339.84 517.632L1339.34 516.601L1340.46 516.859L1340.95 515.826Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.96 520.522L1345.46 521.555L1346.57 521.297L1346.07 522.327L1346.97 523.038L1345.85 523.29L1345.86 524.435L1344.96 523.718L1344.07 524.435L1344.07 523.29L1342.96 523.038L1343.85 522.327L1343.35 521.297L1344.47 521.555L1344.96 520.522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.09 526L1342.48 527.196H1343.74L1342.72 527.935L1343.11 529.131L1342.09 528.392L1341.08 529.131L1341.47 527.935L1340.45 527.196H1341.71L1342.09 526Z",
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10836_135373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1440 310) scale(851.5 228.892)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10836_135373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1080,
    fill: "white",
    transform: "translate(0 -230)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10836_135373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(954 148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10836_135373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(1314 148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_10836_135373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(1098 220)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_10836_135373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(882 292)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_10836_135373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(1242 292)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_10836_135373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(1026 364)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_10836_135373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(1386 364)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_10836_135373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(1170 436)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_10836_135373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(1314 508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicies);
export default __webpack_public_path__ + "static/media/indicies.09353382bf4ab753061a0296a0cb5da0.svg";
export { ForwardRef as ReactComponent };